import PropTypes from 'prop-types';

export default {
	icon: PropTypes.string,
	languageCode: PropTypes.string,
	cultureCode: PropTypes.string,
	name: PropTypes.string,
	isActive: PropTypes.bool,
	isDefault: PropTypes.bool,
};
